/**
 * 상점/벌점 현황
 */
import React, { Component } from 'react';
import { Navbar, ListGroup } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch, faArrowCircleLeft, faAngleUp, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import SideMenuCmp from './SideMenuCmp';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { udfAutoLogin, url, udfInlineLoading, udfNoneLoading } from '../../common/common';
import { udfSetHakgwaList, udfSetLastBan, sc_rule, rule_reload, udfSetSearchCondition, udfSetScInfo } from '../../common/usr/stdtList'
import loader from '../../imgs/ajax-loader.gif';
import { dropByCacheKey } from 'react-router-cache-route'

let firstIndex = 0;	// 불러 올 시작 레코드
const recordCountPerPage = 15;	// 한번에 불러 올 레코드 개수
let isMore = true;	// 불러 올 레코드 존재 여부
let isRunning = false;

let that = this;

class RuleRptCmp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // bootstrap Alert 변수
      alertShow: false,
      alertClickNo: null,
      alertClickYes: null,
      alertClickOk: null,
      alertMessage: null,

      isLoggedIn: null,
      list: [],

      usrInfo: null,
      clGuNm: { B: '상점', R: '벌점', G: '회복', S: '차감' },
    }
    props.cacheLifecycles.didCache(this.componentDidCache)
    props.cacheLifecycles.didRecover(this.componentDidRecover)
  }

  // 스크롤 위치 기억
  scrollPostion = 0;

  // 본 페이지를 떠날때 캐시 저장후 이벤트
  componentDidCache = () => {
    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleHistoryCachce');

    // 스크롤 이벤트 해제
    window.removeEventListener('scroll', this.handleScroll);
  }

  // 케시된 페이지로 바로 다시 돌아 왔을때 캐시 내용 복원 후 이벤트
  componentDidRecover = () => {

    // 케시된 페이지 DROP
    dropByCacheKey('noticeCachce');
    dropByCacheKey('qnaCachce');
    dropByCacheKey('newsCachce');
    dropByCacheKey('stdtListCachce');
    dropByCacheKey('ruleRptCachce');
    dropByCacheKey('ruleHistoryCachce');

    // 스크롤 이벤트 바인딩
    window.addEventListener('scroll', this.handleScroll);

    if (rule_reload) this.udfSelectRuleRpt('Y');
    else {
      // 스크롤 위치 복원
      $(window).scrollTop(this.scrollPostion);
    }
  }

  componentDidMount = () => {
    udfNoneLoading();
    // 자동 로그인 체크
    udfAutoLogin(this).then((data) => {
      if (data !== null && data.userSe === 'STDT') {
        this.props.history.push('/stdt/ruleList');
      } else if (data !== null && data.userSe === 'USR') {
        this.setState({ usrInfo: data, clGuNm: { B: data.BLUE_NM, R: data.RED_NM, G: '회복', S: '차감' } });
        this.udfSelectRuleRpt('Y');
      } else {
        this.props.history.push('/');
      }
    });

    if (this.state.list.length === 0) {
      isMore = true;
      isRunning = false;
      firstIndex = 0;
    }

    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount = () => {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll = () => {
    // 스크롤 위치 기억
    this.scrollPostion = $(window).scrollTop();

    if ($('.wrap-loading').length - $('.wrap-loading.d-none').length !== 0 || $('.modal-backdrop.show').length > 0)
      return false;

    let marginBottom = 71;
    if (window.innerHeight + marginBottom >= Math.ceil(document.getElementsByTagName('body')[0].getBoundingClientRect().bottom) && isMore) {
      this.udfSelectRuleRpt('N');
    }
  }

  udfSelectRuleRpt = (clearYn) => {
    if (!this.state.usrInfo) return;
    if (clearYn === 'Y') {
      firstIndex = 0;
      isMore = true;
      $(window).scrollTop(0);
    }

    that = this;
    if (isMore && !isRunning) {
      udfInlineLoading();
      isRunning = true;

      let setData = {
        isMobile: 'Y',
        firstIndex: firstIndex,
        recordCountPerPage: recordCountPerPage,
        SF_HAKGWA: sc_rule.SF_HAKGWA,
        SF_GRADE: sc_rule.SF_GRADE,
        SF_START_BAN: sc_rule.SF_START_BAN,
        SF_END_BAN: sc_rule.SF_END_BAN,
        SF_SDATE: sc_rule.SF_SDATE,
        SF_EDATE: sc_rule.SF_EDATE,
        SF_KIND: sc_rule.SF_KIND,
        SF_KIND_SP: sc_rule.SF_KIND_SP,
        SF_KIND_EP: sc_rule.SF_KIND_EP,
        SF_CLRL_CD: sc_rule.SF_CLRL_CD,
        SF_CLRL_NM: sc_rule.SF_CLRL_NM,
      };

      $.ajax({
        url: url + '/sli/rule/selectRuleRpt.do',
        type: 'GET',
        dataType: 'jsonp',
        data: setData,
        success: function (data) {
          udfNoneLoading();

          if (!data.success)
            that.componentDidMount();
          else {
            let list = [];
            let hakgwaList = [];
            if (data.resultList !== undefined && data.resultList !== null) {
              var idx = firstIndex;
              $.each(data.resultList, function (i, val) {
                idx++;

                list.push({
                  STD_CD: val.STD_CD,
                  HAKGWA: val.HAKGWA,
                  GRADE: val.GRADE,
                  BAN: val.BAN,
                  BUN: val.BUN,
                  STD_NM: val.STD_NM,
                  RL_DATE: val.RL_DATE,
                  RL_TIME: val.RL_TIME,
                  RL_DESC: val.RL_DESC,
                  POINT: val['POINT_' + val.CL_GU].replace('.0', ''),
                  POINT_B: val.POINT_B,
                  POINT_R: val.POINT_R,
                  POINT_G: val.POINT_G,
                  POINT_S: val.POINT_S,
                  ESNTL_NM: val.ESNTL_NM,
                  POINT_GU: that.state.clGuNm[val.CL_GU],
                });
              });

              // 학과 목록
              udfSetHakgwaList(hakgwaList);
              $.each(data.hakgwaList, function (i, v) {
                hakgwaList.push(v.HAKGWA);
              });

              udfSetHakgwaList(hakgwaList);

              // 마지막 반
              udfSetLastBan(data.lastBan);

              if (idx - firstIndex !== recordCountPerPage) isMore = false;
              firstIndex += recordCountPerPage;

              if (clearYn !== 'Y') list = that.state.list.concat(list);

              udfSetSearchCondition('rule', 'SF_SDATE', data.SF_SDATE);
              udfSetSearchCondition('rule', 'SF_EDATE', data.SF_EDATE);

              if (sc_rule.SF_START_BAN === '') {
                udfSetSearchCondition('rule', 'SF_START_BAN', 1);
                udfSetSearchCondition('rule', 'SF_START_BAN_NM', '1반');
              }

              that.setState({
                isLoggedIn: true,
                list: list
              });
            }
          }

          isRunning = false;
          udfSetScInfo('rule', false, false);
        },
        error: function (jqXHR, status, error) {
          udfNoneLoading();
          isRunning = false;
          that.componentDidMount();
        }
      });
    }
  }

  render() {
    const ruleRpt = this.state.list.map((data, idx) => (
      <Link to={`/usr/stdtRuleHistory/${data.STD_CD}`} key={idx} className='text-dark'>
        <div
          className='row'
          style={{ lineHeight: '180%', margin: '0', padding: '0.75rem 15px' }}
        >
          <div className='pl-0 col-2'><span className={data.POINT_GU === this.state.usrInfo.BLUE_NM ? 'blue-point' : data.POINT_GU === this.state.usrInfo.RED_NM ? 'red-point' : data.POINT_GU === '회복' ? 'green-point' : data.POINT_GU === '차감' ? 'deduction-point' : ''}>{data.POINT_GU}</span></div>
          <div className='pl-0 pr-0 col'>
            <span style={{ float: 'right' }}><FontAwesomeIcon icon={faChevronRight} /></span>
            <div>{data.HAKGWA}{data.HAKGWA !== undefined ? ' ' + data.GRADE : data.GRADE}학년 {data.BAN}반 {data.BUN}번 {data.STD_NM}</div>
            <div className='font-weight-bold'>{data.RL_DATE} {data.RL_TIME}</div>
            <div>{data.RL_DESC}</div>
            <div>
              <span style={{ float: 'left' }}>교사: {data.ESNTL_NM}</span>
              {
                this.state.usrInfo && this.state.usrInfo.RATING_GU !== "Z" ?
                  <span className='point'>{data.POINT} 점</span>
                  : ""
              }
            </div>
          </div>
        </div>
      </Link>
    ));
    return (
      <>
        {/* to the top */}
        <div className='btn-to-top-b1' onClick={() => $(window).scrollTop(0)}><FontAwesomeIcon icon={faAngleUp} /></div>

        <div className='wrap-loading'>
          <img src={loader} alt='로딩 이미지' />
        </div>

        {/* header */}
        <Navbar fixed='top' className='title'>
          <div className="goBackBtn"><div style={{ color: '#fff' }}><FontAwesomeIcon icon={faArrowCircleLeft} className="btn-home" /></div></div>
          {this.state.usrInfo ? this.state.usrInfo.BLUE_NM : '상점'}/{this.state.usrInfo ? this.state.usrInfo.RED_NM : '벌점'} 현황
          <SideMenuCmp
            history={this.props.history}
            usrInfo={this.state.usrInfo}
            alertShow={this.state.alertShow}
            alertMessage={this.state.alertMessage}
            alertClickOk={this.state.alertClickOk}
            alertClickYes={this.state.alertClickYes}
            alertClickNo={this.state.alertClickNo}
          />
        </Navbar>

        <ListGroup variant='flush' style={{ marginTop: '55px' }}>
          <ListGroup.Item className='searchSummary text-muted' onClick={() => this.props.history.push('/usr/ruleSearch')}>
            <FontAwesomeIcon icon={faSearch} className='mr-2' />
            {sc_rule.SF_HAKGWA_NM}&nbsp;·&nbsp;
            {sc_rule.SF_GRADE_NM}&nbsp;·&nbsp;
            {sc_rule.SF_START_BAN_NM}~
            {sc_rule.SF_END_BAN_NM}&nbsp;·&nbsp;
            {sc_rule.SF_SDATE}~
            {sc_rule.SF_EDATE}까지&nbsp;·&nbsp;
            {sc_rule.SF_KIND_NM}&nbsp;·&nbsp;
            {sc_rule.SF_KIND_SP}~
            {sc_rule.SF_KIND_EP}점 까지&nbsp;·&nbsp;
            {sc_rule.SF_CLRL_CD}&nbsp;·&nbsp;
            {sc_rule.SF_CLRL_NM}
          </ListGroup.Item>
        </ListGroup>
        <div className='container-fluid' style={{ padding: '0', marginBottom: '4rem' }}>
          {ruleRpt}
        </div>
      </>
    );
  }
}

export default RuleRptCmp;